import { SingletonRedirect } from "@/components/SingletonRedirect";

export function PromptsList() {
  return <SingletonRedirect resource="prompts" />;
}
